module.exports = __webpack_public_path__ + "static/img/cooperation03.64223bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cooperation03.png
// module id = zI2B
// module chunks = 1